import React, { createContext, useState } from "react";

// Create context for Asset data
export const AssetContextApi = createContext();

const AssetContext = ({ children }) => {
  // Asset global state
  const [assetData, setAssetData] = useState({});
  const [clientAssetData, setClientAssetData] = useState({});
  const [assetCount, setAssetCount] = useState(0);
  const [clientAssetCount, setClientAssetCount] = useState(0);
  const [offset, setOffset] = useState(0);
  const [allOffset, setAllOffset] = useState([0]);
  const [clientAllOffset, setClientAllOffset] = useState([0]);
  // const [currentPage, setCurrentPage] = useState(1);
  const [currentClient, setCurrentClient] = useState(0);
  const [newAssetCount, setNewAssetCount] = useState(0);
  const [deletedAssetCount, setDeletedAssetCount] = useState(0);
  const [newClientAssetCount, setClinetNewAssetCount] = useState(0);
  const [deletedClinetAssetCount, setDeletedClientAssetCount] = useState(0);
  const [shapeData, setShapeData] = useState([]);
  const [metalData, setMetalData] = useState([]);
  const [styleData, setStyleData] = useState([]);
  const [sizeData, setSizeData] = useState([]);

  // Set Asset data into Asset State(assetData)
  const updateAssetState = (newData, page) => {
    setAssetData({ ...assetData, [page]: newData });
  };

  const setAllOffsetState = (newOffset) => {
    setAllOffset((prevState) => [...prevState, newOffset]);
  };
  const setClientAllOffsetState = (newOffset) => {
    setClientAllOffset((prevState) => [...prevState, newOffset]);
  };

  // Set client Asset data into Asset State(clientAssetData)
  const updateClientAssetData = (newData, page) => {
    setClientAssetData({ ...clientAssetData, [page]: newData });
  };

  // Set Asset list count into Asset State(assetCount)
  const assetListCount = (data) => {
    setAssetCount(data);
  };

  // Set client Asset list count into clientAsset State(clientAssetCount)
  const clientAssetListCount = (data) => {
    setClientAssetCount(data);
  };

  // Set offset into offSet State(offset)
  const updateAssetOffset = (newOffset) => {
    setOffset(newOffset);
  };

  const resetAssetState = () => {
    setAssetData({});
    setAllOffset([1]);
    setAssetCount(0);
  };

  const resetClientAssetState = () => {
    setAllOffset([1]);
    setClientAssetData({});
    setClientAssetCount(0);
  };

  // Edit client asset and update cient asset list
  const editClientAssetList = (editedData) => {
    const newClientAssetData = clientAssetData.map((assetInfo) => {
      if (assetInfo.id === editedData.id) {
        return editedData;
      }
      return assetInfo;
    });
    setClientAssetData(newClientAssetData);
  };

  // Add new client asset in client asset list
  const addNewClientAsset = (newAssetData) => {
    clientAssetData.unshift(newAssetData);
  };

  // Set current client id
  const updateCurrentClientId = (newAssetData) => {
    setCurrentClient(newAssetData);
  };

  // Set current client id
  const deleteAssetData = (newAssetData) => {
    setAssetData(newAssetData);
  };

  // Set current client id
  const deleteClientAssetData = (newAssetData) => {
    setClientAssetData(newAssetData);
  };

  return (
    <AssetContextApi.Provider
      value={{
        assetData,
        offset,
        clientAssetData,
        assetCount,
        clientAssetCount,
        currentClient,
        newAssetCount,
        deletedAssetCount,
        newClientAssetCount,
        deletedClinetAssetCount,
        shapeData,
        metalData,
        styleData,
        sizeData,
        updateAssetState,
        updateAssetOffset,
        editClientAssetList,
        resetAssetState,
        addNewClientAsset,
        setClientAssetData,
        updateClientAssetData,
        assetListCount,
        clientAssetListCount,
        updateCurrentClientId,
        deleteAssetData,
        deleteClientAssetData,
        setNewAssetCount,
        setDeletedAssetCount,
        setClinetNewAssetCount,
        setDeletedClientAssetCount,
        allOffset,
        setAllOffsetState,
        resetClientAssetState,
        clientAllOffset,
        setClientAllOffsetState,
        setShapeData,
        setMetalData,
        setStyleData,
        setSizeData
      }}
    >
      {children}
    </AssetContextApi.Provider>
  );
};

export default AssetContext;
